export const useDefaultData = ({ Helpers }) => {

    const { getCurrentDate } = Helpers
    
    const defaultDataModal = {
        open: false,
        titleModal: '',
        componentModal: '',
        dataRequest: {},
    }

    const defaultFormScreen = {
        idgestion: '',
        idgestiontipo: '',
        idcaja: '',
        idusuario: '',
        idcaja_destino: '',
        idbanco: '',
        numero_comprobante: '',
        numero_serie_factura: '',
        monto_solicitado: '',
        monto_solicitado_mask: '',
        monto_aprobado: '',
        monto_aprobado_mask: '',
        tipo_cambio: 7.8,
        tipo_cambio_mask: '7.8',
        monto_convertido: '',
        monto_convertido_mask: '',
        descripcion_servicio: '',
        limite_pago_servicio: '',
        limite_pago_servicio_mask: '',
        descripcion: '',
        aprobacion_check: '',
        aprobacion_usuario: '',
        aprobacion_fecha: getCurrentDate(),
        aprobacion_observaciones: '',

        // auxiliares
        idcategoria: '',
        currency_type: '',
        // files: [],
        fileRejections: [],
        acceptedFiles: [],
        attachments: []
    }

    return Object.freeze({
        defaultDataModal,
        defaultFormScreen
    })
}